import * as sup from "superstruct";

import { createResourceStruct } from "@/modules/api/utils/jsonApiStructs";

import { levelsItemIdentifierStruct } from "./levelsIdentifierStruct";

const levelsItemResourceStruct = createResourceStruct({
  identifier: levelsItemIdentifierStruct,
  attributes: sup.object({
    name: sup.string(),
    order: sup.integer(),
    seniorityValue: sup.number(),
    seniorityUnit: sup.union([
      sup.literal("DAYS"),
      sup.literal("MONTHS"),
      sup.literal("WEEKS"),
      sup.literal("YEARS"),
    ]),
    pointsNumber: sup.number(),
    averageRating: sup.number(),
    seniorityDays: sup.integer(),
  }),
  meta: sup.object({
    tutorialCount: sup.integer(),
    taskCount: sup.integer(),
    progress: sup.object({
      completedTutorialCount: sup.integer(),
      pointsNumber: sup.number(),
      averageRating: sup.number(),
      seniorityDays: sup.integer(),
    }),
  }),
});

export const levelsResourceStruct = sup.array(levelsItemResourceStruct);
